export enum InvoiceStatuses {
  checked = 'CHECKED',
  confirmed = 'CONFIRMED',
  credited = 'CREDITED',
  emailed = 'EMAILED',
  pending = 'PENDING',
  posted = 'POSTED',
  printed = 'PRINTED',
  // An unposted invoice with nothing left to charge, closed for good but keeping its number (4Spaces, D-14).
  void = 'VOID',
}
